import React, { memo } from 'react';
import { MultiStepWizard } from '@dekafvv/sharedfrontend';
import { useLanguage } from '@hydrogen/elements.core.i18n';
import { forgotPasswordSteps } from './steps/forgotPasswordSteps';

// TODO!!!!!
// Move SimpleWizard from AH to SharedFronted and use it here

const ForgotPasswordModal: React.FC<Props> = ({ visible, onClose }) => {
    const { t } = useLanguage();

    if (!visible) {
        return null;
    }

    return (
        <MultiStepWizard
            steps={forgotPasswordSteps(t)}
            onClose={onClose}
            visible={visible}
            closeLabel={t('button.close')}
        />
    );
};

type Props = {
    visible: boolean;
    onClose: ()=>void
}

export const ForgotPassword = memo(ForgotPasswordModal);
